import get from '../functions/localstorage/get';
import put from '../functions/localstorage/put';


export default {
  name: 'LocalStorageMixin',
  data() {
    return {
      localStoragePrefix: 'app:',
    };
  },
  methods: {
    put(key, value) {
      return put(key, value, this.localStoragePrefix);
    },
    get(key, def = '') {
      return get(key, def, this.localStoragePrefix);
    },
  },
};
